import { IAprovacaoAlteracaoLancamento } from "../interfaces/IAprovacaoAlteracaoLancamento";
import { IArquivoCardEsteira } from "../interfaces/IArquivoCardEsteira";
import api from "./Api";

export interface ILancamentoSnapshot {
    codigoContabil: string;
    descricaoCodigoContabil?: string;
    historico?: string;
    valorProvisaoRecolher?: number;
    tipoLancamento: string;
    status: string;
    dataLancamento: string;
}

export interface IAlteracaoComStatus {
    id: number;
    esteiraId: number;
    lancamentoId: number;
    operacaoId: number;
    tipo: string;
    valor?: string;
    usuarioCadastrouOperacaoId: number;
    nomeCadastrou?: string;
    usuarioAprouOperacaoId?: number;
    nomeAprou?: string;
    usuarioReprouOperacaoId?: number;
    nomeReprou?: string;
    dataCadastro: string;
    dataAprovacao?: string;
    dataReprovacao?: string;
    processando: boolean;
    processou: boolean;
    erro: boolean;
    status: string;
    antes?: ILancamentoSnapshot;
    depois?: ILancamentoSnapshot;
}

class ArquivoCardEsteiraService {
    async cadastrarArquivo(esteira: number, codigoContabil: string, nome: string, url: string): Promise<IArquivoCardEsteira> {
        let { data: result } = await api.post<IArquivoCardEsteira>('ArquivoCardEsteira', { esteiraID: esteira, codigoContabil, nome, url });

        return result;
    }

    async buscarAlteracoesPendentes(esteiraID: number): Promise<IAprovacaoAlteracaoLancamento[]> {
        const { data: result } = await api.get<IAprovacaoAlteracaoLancamento[]>(`AlteracaoLancamento/pendentes/${esteiraID}`)
        return result;
    }

    async buscarAlteracoesAprovadas(esteiraID: number): Promise<IAprovacaoAlteracaoLancamento[]> {
        const { data: result } = await api.get<IAprovacaoAlteracaoLancamento[]>(`AlteracaoLancamento/aprovadas/${esteiraID}`)
        return result;
    }

    async aceitarAlteracao(id: number[]): Promise<void> {
        await api.post(`AlteracaoLancamento/aceitar`, id);
    }

    async recusarAlteracao(id: number[]): Promise<void> {
        await api.post(`AlteracaoLancamento/recusar`, id);
    }

    async solicitarAlteracao(payload: {
        esteiraId: number;
        lancamentoId: number;
        tipo: 'HISTORICO' | 'VALOR' | 'CONTA' | 'ESTORNO';
        historico?: string;
        valor?: string;
        conta?: string;
    }): Promise<void> {
        await api.post('AlteracaoLancamento/solicitar', payload);
    }

    async alterarHistorico(id: number, historico: string, esteiraId: number): Promise<void> {
        await this.solicitarAlteracao({ esteiraId, lancamentoId: id, tipo: 'HISTORICO', historico });
    }

    async alterarValor(id: number, valor: string, esteiraId: number): Promise<void> {
        await this.solicitarAlteracao({ esteiraId, lancamentoId: id, tipo: 'VALOR', valor });
    }

    async alterarConta(items: { lancamentoID: number; conta: string; esteiraId: number }[]): Promise<void> {
        for (const item of items) {
            await this.solicitarAlteracao({ esteiraId: item.esteiraId, lancamentoId: item.lancamentoID, tipo: 'CONTA', conta: item.conta });
        }
    }

    async alterarEstorno(id: number, esteiraId: number): Promise<void> {
        await this.solicitarAlteracao({ esteiraId, lancamentoId: id, tipo: 'ESTORNO' });
    }

    async solicitarAlteracaoLote(esteiraId: number, lancamentoIds: number[], conta: string): Promise<void> {
        await api.post('AlteracaoLancamento/solicitar/lote', { esteiraId, lancamentoIds, conta });
    }

    async buscarAlteracoesPendentesNova(esteiraID: number): Promise<{ lancamentoId: number; id: number; tipo: string }[]> {
        const { data: result } = await api.get<{ lancamentoId: number; id: number; tipo: string }[]>(`AlteracaoLancamento/pendentes-nova/${esteiraID}`);
        return result;
    }

    async aprovarAlteracao(id: number): Promise<void> {
        await api.post(`AlteracaoLancamento/${id}/aprovar`);
    }

    async reprovarAlteracao(id: number): Promise<void> {
        await api.post(`AlteracaoLancamento/${id}/reprovar`);
    }

    async aprovarAlteracoesEmLote(esteiraId: number, ids: number[]): Promise<{ operacaoId: number; total: number }> {
        const { data: result } = await api.post(`AlteracaoLancamento/aprovar-lote`, { esteiraId, ids });
        return result;
    }

    async buscarNotificacoes(esteiraID: number): Promise<any> {
        const { data: result } = await api.get<any>(`Esteira/Notificacoes/${esteiraID}`);
        return result;
    }

    async buscarTodasAlteracoes(esteiraID: number): Promise<IAlteracaoComStatus[]> {
        const { data: result } = await api.get<IAlteracaoComStatus[]>(`AlteracaoLancamento/todas/${esteiraID}`);
        return result;
    }
}


export default new ArquivoCardEsteiraService();